export const workspaces = {
  'Workstation': 'Workstation',
  'PrivateOffice': 'Private Office',
  'FlexDesk': 'Flex Desk',
  'MeetingRoomSmall': 'Meeting Room Small',
  'MeetingRoomMedium': 'Meeting Room Medium',
  'MeetingRoomLarge': 'Meeting Room Large',
  'HotelRoom': 'Hotel Room',
};
